import { Injectable } from '@angular/core';
import { MdlSnackbarService } from '@angular-mdl/core';

import { TranslateService } from '../../translate/translate.service';

@Injectable()
export class SnackbarService {

    displayMessage: any = '';
    constructor(
        private _mdlSnackbarService: MdlSnackbarService,
        private _translate: TranslateService
    ) {
    }

    /**
    * @param  {any} snackBarKey langauage key of message to be disabled
    * @param  {string} type category - error/success/info - by default info
    * @param  {any} value value to display in snackbar
    */
    showSnackbar(snackBarKey: any, type: string, value?: any) {
        this.displayMessage = this._translate.instant(snackBarKey);

        if (document.body.classList.contains('success-toast')) {
            document.body.classList.remove('success-toast');
        }
        if (document.body.classList.contains('error-toast')) {
            document.body.classList.remove('error-toast');
        }
        if (document.body.classList.contains('info-toast')) {
            document.body.classList.remove('info-toast');
        }

        if (type === 'error') {
            document.body.classList.add('error-toast');
        } else if (type === 'success') {
            document.body.classList.add('success-toast');
        } else if (type === 'info') {
            document.body.classList.add('info-toast');
        } else {
            document.body.classList.add('info-toast');
        }

        if (value === undefined) {
            this.generateSnackbar(this.displayMessage);
        } else {
            this.generateSnackbar(this.displayMessage + value);
        }
    }

    generateSnackbar (snackBarMessage:any) {
        this._mdlSnackbarService.showSnackbar({
            message: snackBarMessage,
            timeout: 10000,
            closeAfterTimeout: true,
            action: {
                handler: () => {
                    // This is intentional
                },
                text: ''
            }
        });
    }
}